import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Landmark } from 'lucide-react';
export const Hero = () => {
  return <section className="relative pt-8 pb-10 md:pt-10 md:pb-12 overflow-hidden" data-id="element-122" data-mp="eilej673gxdk">
      {/* Background Grid & Glow */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:40px_40px] opacity-20 pointer-events-none" data-id="element-123" data-mp="9igwhbqjful8"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-gold-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-124" data-mp="xae7j0m5yila" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-125" data-mp="s9zwrat6gujk">
        <div className="flex flex-col items-center text-center max-w-5xl mx-auto" data-id="element-126" data-mp="ncgiiawhchrm">
          {/* Title */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black leading-[1.15] mb-6 font-[Poppins,_sans-serif] tracking-tight" data-id="element-127" data-mp="3d21v45faeyrf">
            <span className="text-gold-500" data-id="element-128" data-mp="399bavmrkdbvg">Trabajá más rápido</span>
            <span className="text-white" data-id="element-129" data-mp="3e961rqbca1gi">, con </span>
            <span className="text-red-500" data-id="element-130" data-mp="3e7uzjuxjl1ri">mayor seguridad</span>
            <span className="text-white" data-id="element-131" data-mp="30hrev8eb9g46">
              {' '}
              y sin perder horas buscando información.
            </span>
          </motion.h1>

          {/* Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          y: 24,
          scale: 0.96
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="w-full max-w-2xl my-6 md:my-8" data-id="element-132" data-mp="2qkdboaheentt">
            <img src="https://cdn.magicpatterns.com/uploads/8vusK3BjTiygegHG7CVihw/9df2604d-0b60-495e-b28a-bd3b1bdfa3c4.png" alt="Megapack Profesional del Abogado Moderno: los 6 módulos en cuadernillos junto al material visto en computadora, tablet y celular con los bonos exclusivos" className="w-full h-auto drop-shadow-2xl" data-id="element-133" data-mp="s2b9g2qj4r79" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col items-center" data-id="element-134" data-mp="1b15lh3ylzdjq">
            {/* CTA */}
            <motion.a href="#oferta" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 hover:bg-gold-400 text-legal-900 font-bold rounded-lg text-lg transition-colors shadow-[0_0_20px_rgba(201,162,74,0.3)] bg-[#62C94A]" data-id="element-135" data-mp="3lsp33cogahdw">
              QUIERO MI MEGAPACK AHORA
            </motion.a>

            {/* Trust Badges */}
            <div className="mt-8 flex flex-wrap justify-center items-center gap-4 sm:gap-6 text-sm text-slate-400" data-id="element-136" data-mp="269hda79kp94c">
              <div className="flex items-center gap-1.5" data-id="element-137" data-mp="2b0zhr5at1ru2">
                <ShieldCheck className="w-4 h-4" data-id="element-138" data-mp="2b2k6geafugk0" />
                Garantía 7 días
              </div>
              <div className="flex items-center gap-1.5" data-id="element-139" data-mp="2kyvnfhkz3uks">
                <ShieldCheck className="w-4 h-4" data-id="element-140" data-mp="2kxc6dorhtfhy" />
                Pago 100% seguro
              </div>
              <div className="flex items-center gap-1.5" data-id="element-141" data-mp="2p10dy7g4kb37">
                <CreditCard className="w-4 h-4" data-id="element-142" data-mp="2u03jru3xilc8" />
                Mercado Pago | Tarjeta
              </div>
              <div className="flex items-center gap-1.5" data-id="element-143" data-mp="un9ajpoe2ng7">
                <Landmark className="w-4 h-4" data-id="element-144" data-mp="uou5hgem88el" />
                Transferencia
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};